import { UseBaseQueryResult } from '@tanstack/react-query';
import { RequestStatus } from '../../types';

export type QueryResultStatus = Pick<UseBaseQueryResult, 'status'>;

export const getStatusFromQueries = (...args: QueryResultStatus[]): RequestStatus =>
  args.slice(0).reduce((acc, queryResult, index, array) => {
    if (acc === 'error' || queryResult.status === 'error') {
      array.slice(1);
      return 'error';
    }
    if (acc === 'loading' || queryResult.status === 'loading') {
      return 'loading';
    }
    return queryResult.status === 'success' ? 'success' : 'none';
  }, 'none' as RequestStatus);
